import * as ACTION from '../containers/About/actionTypes';

const initialState = {
  loading: false,
};

const registersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.LOADING_PAGE_ABOUT:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default registersReducer;
